import router from '@/router';

const actions = {
  redirectToEdit({ state }) {
    if (state.editUrl && state.isCLVideoReady) {
      router.push(state.editUrl);
    }
  },
  redirectToClDownload({ state }) {
    if (state.editUrl) {
      router.push(`${state.editUrl}?download=true`);
    }
    if (state.editUrl) {
      router.push(`${state.editUrl}?download=true`);
    }
  }
};

export default actions;
